const OFFER_INTERACTION = 'offerInteraction';
const PAGE_OVERLAY = 'overlayLoad';
const OFFER_IMPRESSION = 'offerImpression';
const PAGE_LOAD = 'pageLoad';

// Define the type for the event detail object
interface EventDetail {
  offerId?: string;
  interactionLabel?: string;
  overlay?: string;
  page?: string;
}

// Define the eventDispatcher function with proper types
const eventDispatcher = (
  eventType: string,
  offerId?: string,
  interactionLabel?: string,
  overlay?: string,
  page?: string,
): CustomEvent | void => {
  if (!eventType) {
    console.log('Required: No event type provided');
    return;
  }

  try {
    const detail: EventDetail = {};

    if (offerId) {
      detail.offerId = offerId;
    }
    if (interactionLabel) {
      detail.interactionLabel = interactionLabel;
    }
    if (overlay) {
      detail.overlay = overlay;
    }
    if (page) {
      detail.page = page;
    }

    // Instantiate a CustomEvent with an eventType
    const event = new CustomEvent(eventType, { detail });
    // Dispatch the CustomEvent from the document body
    document.body.dispatchEvent(event);

    console.log('event is dispatched');
    return event;
  } catch (e) {
    console.error('Error dispatching event:', e);
  }
};

// Define the dispatchInteraction function with proper types
export const dispatchInteraction = (
  offerId: string,
  interactionLabel: string,
): CustomEvent | void => {
  return eventDispatcher(OFFER_INTERACTION, offerId, interactionLabel);
};

// Define the dispatchOverlayLoad function with proper types
export const dispatchOverlayLoad = (overlay: string): CustomEvent | void => {
  return eventDispatcher(PAGE_OVERLAY, undefined, undefined, overlay);
};

/**
 * Function for instantiating and dispatching a JavaScript CustomEvent for
 * signaling an impression of a Targeted Messaging offer.
 *
 * @param {string} offerId - Unique identifier of the offer.
 */
export function dispatchOfferImpression(offerId: string): CustomEvent | void {
  return eventDispatcher(OFFER_IMPRESSION, offerId);
}

// Define the dispatchPageLoad function with proper types
export const dispatchPageLoad = (page: string): CustomEvent | void => {
  return eventDispatcher(PAGE_LOAD, undefined, undefined, undefined, page);
};
